// @flow
import * as React from 'react';
import { connect } from 'react-redux';

import { Container, Row, Col } from 'reactstrap';

import {
  comment,
  editComment,
  deleteReport,
  loadSingleReport,
} from 'actions/reports';
import type { SingleReport } from 'actions/reports';

import Timeline from 'components/Timeline';
import type { TimelineEntry } from 'components/Timeline/TimelineEntry';
import Map from 'components/Map';
import ChangeStatus from 'components/ChangeStatus';
import EmergencyBreak from 'components/EmergencyBreak';
import Hero from 'components/Hero';

type Props = {
  // redux
  report: ?SingleReport,
  entries: Array<TimelineEntry>,
  onLoadSingleReport: () => mixed,
  onComment: (text: string) => mixed,
  onEditComment: (index: number, text: string) => void,
  onDeleteReport: (reason: string) => void,
};

class ReportComponent extends React.Component<Props> {
  componentDidMount() {
    this.props.onLoadSingleReport();
  }

  _onDelete = async reason => {
    const { onDeleteReport, onLoadSingleReport } = this.props;
    await onDeleteReport(reason);
    await onLoadSingleReport();
  };

  _onEditComment = async (index, text) => {
    const { onEditComment, onLoadSingleReport } = this.props;
    await onEditComment(index, text);
    await onLoadSingleReport();
  };

  render() {
    const { entries, report, onComment, onLoadSingleReport } = this.props;
    if (!report) {
      return null;
    }
    const {
      reportId,
      street,
      zip,
      city,
      status,
      title,
      description,
      images,
      createdAt,
      createdBy,
    } = report;
    const isDeleted = status === 'deleted';

    return (
      <Container fluid>
        <Row>
          <Col>
            <Hero
              title={title}
              description={description}
              images={images}
              createdAt={createdAt}
              createdBy={{
                ...createdBy,
                isCreatedByManager: false,
              }}
              maxImages={4}
            />
            <Timeline
              entries={entries}
              editable={!isDeleted}
              onComment={onComment}
              onReloadData={onLoadSingleReport}
              onCommentEdited={this._onEditComment}
            />
          </Col>
          <Col xs="12" sm="12" md="12" lg="5" xl="5">
            <Map street={street} zip={zip} city={city} />
            {!isDeleted && (
              <ChangeStatus reportId={reportId} currentState={status} />
            )}
            {!isDeleted && (
              <EmergencyBreak type="Meldung" onDelete={this._onDelete} />
            )}
          </Col>
        </Row>
      </Container>
    );
  }
}

const mapStateToProps = (
  {
    auth: {
      user: { userId },
    },
    reports: { singles: reports },
  },
  props
) => {
  const { reportId } = props.match.params;
  const report = reports[reportId];
  const entries = report
    ? [
        ...report.comments.map((c, index) => ({
          type: 'comment',
          createdByEmail: c.createdByEmail,
          createdByName: `${c.firstname} ${c.lastname}`,
          isCreatedByManager: c.isCreatedByManager,
          text: c.text,
          createdAt: c.createdAt,
          isOwnEntry: c.userId === userId,
          commentIndex: index,
        })),
        ...report.likes.map(l => ({
          type: 'like',
          createdByEmail: l.createdByEmail,
          createdByName: `${l.firstname} ${l.lastname}`,
          isCreatedByManager: l.isCreatedByManager,
          createdAt: l.createdAt,
        })),
        ...report.states.map(s => ({
          type: 'state',
          isCreatedByManager: true,
          createdAt: s.createdAt,
          text: s.state,
        })),
      ].sort((a, b) => a.createdAt - b.createdAt)
    : [];
  return {
    report: reports[reportId],
    entries,
  };
};
const mapDispatchToProps = (dispatch, props) => {
  const { reportId } = props.match.params;
  return {
    onDeleteReport: reason => dispatch(deleteReport(reportId, reason)),
    onLoadSingleReport: () => dispatch(loadSingleReport(reportId)),
    onComment: text => dispatch(comment(reportId, text)),
    onEditComment: (index, text) =>
      dispatch(editComment(reportId, index, text)),
  };
};

const ReportContainer = connect(
  mapStateToProps,
  mapDispatchToProps
)(ReportComponent);

export default ReportContainer;



// WEBPACK FOOTER //
// ./src/views/Report/Report.js